import * as amplitude from '@amplitude/analytics-browser'

import { dispatchAmplitudeCustomEvent } from './dispatchAmplitudeCustomEvent'
import { setCookie } from '../cookies'

type AmplitudeEvent = {
  eventName: string
  eventData: Record<string, unknown> | undefined | null
}

const AMPLITUDE_API_KEY = 'fa79c244a3f2441593b2fee565ec63eb' // [DEV] Ecommerce Brazil Web

const isBrowser = typeof window !== 'undefined'

if (isBrowser) {
  amplitude.init(AMPLITUDE_API_KEY, { serverZone: 'EU' })
}

function removeProperties<T extends Record<string, unknown>, K extends keyof T>(
  obj: T,
  props: K[]
): Omit<T, K> {
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !props.includes(key as K))
  ) as Omit<T, K>
}

function persistLastEvent(
  eventName: string,
  eventData: Record<string, unknown>
) {
  setCookie(eventName, JSON.stringify(eventData))
}

export const dispatchAmplitudeEvent = ({
  eventName,
  eventData,
}: AmplitudeEvent) => {
  if (!isBrowser || !eventData) {
    return
  }

  const propertiesToRemoveAmplitude = [
    'standard event properties',
    'website_features_details',
  ]

  const propertiesToRemoveCustomData = [
    'local timestamp',
    'local timestamp identifier',
    'website domain',
    'page path',
    'page title',
    'page full url',
    'referring domain',
    'full referrer',
    'page name',
    'page type',
    'page language',
    'previous page type',
    'previous page name',
    'page platform',
    'page number viewed',
    'location on page',
    'type',
    'name',
  ]

  const eventDataAmplitude = removeProperties(
    eventData,
    propertiesToRemoveAmplitude
  )

  const eventDataCustomData = removeProperties(
    eventData,
    propertiesToRemoveCustomData
  )

  amplitude.track(eventName, eventDataAmplitude)
  dispatchAmplitudeCustomEvent({ eventName, eventData: eventDataCustomData })

  if (
    eventName === 'Promotional Element Selected' &&
    'website_features_details' in eventDataCustomData
  ) {
    persistLastEvent(
      'promotional_element_selected',
      eventDataCustomData.website_features_details as Record<string, unknown>
    )
  }
}

type InputValue =
  | string
  | number
  | null
  | undefined
  | InputObject
  | InputValue[]
interface InputObject {
  [key: string]: InputValue
}
